import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardSmartProperty } from './CardSmartProperty';
import { ArtificialIntelligenceEnhancedIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const dataSourceLabels = {
  PROPERTY_DATA: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.propertyData"
  }),
  WEB: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.web"
  }),
  DOMAIN_CRAWLER: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartPropertyTemplates.labels.domainCrawler"
  })
};
export const LabelDataSource = ({
  dataSource
}) => {
  return /*#__PURE__*/_jsx(CardSmartProperty.PropertyLabel, {
    icon: /*#__PURE__*/_jsx(ArtificialIntelligenceEnhancedIcon, {}),
    children: dataSourceLabels[dataSource]
  });
};